import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import VaikhanasamPage from "./pages/VaikhanasamPage";
import EventsPage from "./pages/EventsPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import CompleteRegistrationPage from "./pages/CompleteRegistrationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ProfilePage from "./pages/ProfilePage";
import DonatePage from "./pages/DonatePage";
import ArticlesPage from "./pages/ArticlesPage";
import AdminPage from "./pages/AdminPage";
import AdminRoute from "./pages/AdminRoute";
import RoleRoute from "./pages/RoleRoute";
import PrivateRoute from "./pages/PrivateRoute";
import YoutubePage from "./pages/YoutubePage";
import ContentManagementPage from "./pages/ContentManagementPage";
import BookCatalogPage from "./pages/BookCatalogPage";
import { AuthProvider } from "./pages/AuthContext";
import { UsersProvider } from "./pages/UsersContext";
import { RefreshProvider } from "./pages/RefreshContext";
import Layout from "./components/Layout";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <RefreshProvider>
        <UsersProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="vaikhanasam" element={<VaikhanasamPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="donate" element={<DonatePage />} />
            <Route path="articles" element={<ArticlesPage />} />
            <Route path="youtube" element={<YoutubePage />} />
            <Route path="content-management" element={<ContentManagementPage />} />
            <Route path="books" element={<PrivateRoute><BookCatalogPage /></PrivateRoute>} />
            <Route path="admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
            <Route path="login" element={<LoginPage />} />
            <Route path="signup" element={<SignupPage />} />
            <Route path="complete-registration" element={<CompleteRegistrationPage />} />
            <Route path="forgot-password" element={<ForgotPasswordPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
          </Route>
        </Routes>
        </UsersProvider>
        </RefreshProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;